import { useState } from 'react';

export interface ConversationMessage {
  role: 'user' | 'assistant';
  content: string;
}

export function useConversationHistory() {
  const [history, setHistory] = useState<ConversationMessage[]>([]);

  function addMessage(message: ConversationMessage) {
    setHistory(prev => {
      // Prevent duplicate consecutive messages
      const lastMessage = prev[prev.length - 1];
      if (
        lastMessage?.role === message.role &&
        lastMessage?.content === message.content
      ) {
        return prev;
      }
      return [...prev, message];
    });
  }

  function clear() {
    setHistory([]);
  }

  return {
    history,
    addMessage,
    clear,
    hasHistory: history.length > 0,
    messageCount: history.length,
  };
}
